import React, { useState } from 'react'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion'
import { IoIosArrowBack } from 'react-icons/io'

const CustomAccordion = ({ header, listItems, type }) => {
  const [rotationState, setRotationState] = useState(false)

  const toggleRotation = () => {
    setRotationState(!rotationState)
  }

  const accordionTransitionDuration = 500 // Set the same duration as the accordion transition

  const accordionClass = () => {
    switch (type) {
      case 'rounded':
        return 'max-w-[500px] mx-auto border-accordionBorderColor bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor rounded-2xl border-[4px] shadow-lg'
      case 'rectangle':
        return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg'
      default:
        return ''
    }
  }

  return (
    <div className="mt-6 mx-auto px-4">
      <Accordion
        className={accordionClass()}
        transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
      >
        <AccordionItem>
          <AccordionHeader
            className="bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl"
            onClick={toggleRotation}
          >
            <IoIosArrowBack
              className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
              style={{ transition: `transform 0.5s ease-in-out` }}
            />
            <h3 className="text-2xl font-bold ">{header}</h3>
          </AccordionHeader>

          <AccordionBody>
            <div dir="rtl" className="text-accordionTextColor text-right font-medium p-4 rounded-b-2xl">
              <ul className="mr-5">
                {listItems &&
                  listItems.map((item, index) => (
                    <li className="mb-3 text-lg list-disc" key={index}>
                      {item}
                    </li>
                  ))}
              </ul>

              {/* <h3 className="text-2xl mt-4 font-bold ">מסלולים</h3>
              <ul className="mr-5 mt-2">
                <li className="mb-3 text-lg list-disc">
                  <span className="font-bold text-yellow-100">יעוץ יומי</span> - שעתיים של פגישה ולאחר מכן סבב רכישות.
                </li>
                <li className="mb-3 text-lg list-disc">
                  <span className="font-bold text-yellow-100">יעוץ שעתי</span>
                </li>
                <li className="mb-3 text-lg list-disc">
                  <span className="font-bold text-yellow-100">עיצוב פנים כולל</span> - מ-א' ועד ת', מעטפת מלאה לעיצוב
                  הבית, יצירת סט תוכניות עבודה מפורט לביצוע, ניהול תקציב, ניהול פרוייקט מול קבלנים ואנשי מקצוע, הלבשה
                  וסטיילינג.
                </li>
              </ul> */}
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default CustomAccordion
